'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseIcons = require('@bibliocommons/base-icons');

var _alert = require('../../alert');

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertInfo = function AlertInfo(_ref) {
  var handleDismiss = _ref.handleDismiss,
      children = _ref.children;
  return _react2.default.createElement(
    _alert2.default,
    {
      className: 'alert-info cp-alert-info',
      renderIcon: function renderIcon() {
        return _react2.default.createElement(_baseIcons.Info, null);
      },
      handleDismiss: handleDismiss },
    children
  );
};

AlertInfo.propTypes = {
  handleDismiss: _react.PropTypes.func,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
};

exports.default = AlertInfo;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/info/components/AlertInfo.component.js
// module id = 875
// module chunks = 0 3